import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import {initialState} from '../sample.reducer';
import {DefaultButton, Filter, WarningButton} from "../../../components";

const Container = styled.div`
  margin-bottom: 1rem;
  & select, button {
    margin-right: 1rem;
  }
`;

class Filters extends React.Component {
  state = {
    filters: initialState.filters,
    hasSearched: false
  };

  clearFilters = () => this.setState({filters: initialState.filters, hasSearched: false}, this.props.clear);
  searchFilters = () => this.setState({hasSearched: true}, () => this.props.search(this.state.filters));
  setFilter = filter => value => this.setState(state => ({filters: {...state.filters, [filter]: value}}));

  componentWillMount() {
    this.setState({filters: this.props.filters})
  }

  /*clear all but facility filter.*/
  componentWillUnmount() {
    // const {search, filters} = this.props;
    // search({reviewer: '', recordStatus: '', facility: filters.facility});
  }

  componentWillUpdate(nextProps) {
    const {hasSearched, filters} = this.state;
    if (hasSearched && filters !== nextProps.filters) {
      this.setState({filters: nextProps.filters});
    }
  }

  renderAllFilters() {
    const {
      facilities,
      reviewers,
      recordStatuses
    } = this.props;

    const {filters} = this.state;

    return (
      <React.Fragment>
        <div className="col-sm-3">
          <Filter
            items={facilities}
            title="Select Facility"
            filter={filters.facility}
            onSelect={this.setFilter('facility')}
            renderOption={x => <option key={x.id} value={x.id}>{x.name}</option>}
          />
        </div>
        <div className="col-sm-3">
          <Filter
            items={recordStatuses}
            title="Select Status"
            filter={filters.recordStatus}
            onSelect={this.setFilter('recordStatus')}
            renderOption={x => <option key={x} value={x}>{x}</option>}
          />
        </div>
        <div className="col-sm-3">
          <Filter
            items={reviewers}
            title="Select Reviewer"
            filter={filters.reviewer}
            onSelect={this.setFilter('reviewer')}
            renderOption={x => <option key={`${x.firstName} ${x.lastName}`} value={`${x.firstName} ${x.lastName}`}>{`${x.firstName} ${x.lastName}`}</option>}
          />
        </div>
      </React.Fragment>
    )
  }

  renderFacilityFilter() {
    const {facilities} = this.props;
    const {filters} = this.state;
    return (
      <div className="col-sm-7">
        <Filter
          items={facilities}
          title="Select Facility"
          filter={filters.facility}
          onSelect={this.setFilter('facility')}
          renderOption={x => <option key={x.id} value={x.id}>{x.name}</option>}
        />
      </div>
    );
  }

  render() {
    const {filters} = this.state;
    const {others:showAllFilters} = this.props;
    const enabled = Object.keys(filters).some(x => Boolean(filters[x]));
    return (
      <Container>
        <div className="row">
          {showAllFilters ? this.renderAllFilters() : this.renderFacilityFilter()}
          <div className={`col-sm-${showAllFilters ? 3 : 5}`}>
            <WarningButton disabled={!enabled} onClick={this.searchFilters}>Search</WarningButton>
            <DefaultButton disabled={!enabled} onClick={this.clearFilters}>Reset</DefaultButton>
            {this.props.children}
          </div>
        </div>
      </Container>
    );
  }
}

Filters.defaultProps = {
  others: false,
};

Filters.propTypes = {
  filters: PropTypes.object.isRequired,
  facilities: PropTypes.array.isRequired,
  reviewers: PropTypes.array,
  recordStatuses: PropTypes.array,
  others: PropTypes.bool,
  search: PropTypes.func.isRequired,
  clear: PropTypes.func.isRequired,
};

export default Filters;



// WEBPACK FOOTER //
// ./src/modules/sample/components/Filters.js